// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorBox_errorPage__EtIP9","errorIcon":"ErrorBox_errorIcon__FEghZ","errorTitle":"ErrorBox_errorTitle__o0sDR","homePageButton":"ErrorBox_homePageButton__PIsz0"};